import { ThemeConfig } from "antd";

export const antdDarkTheme: ThemeConfig["token"] = {
  colorPrimary: '#4C6AFF',
  colorTextBase: 'rgba(255, 255, 255, 0.94)',
  controlItemBgHover: 'rgba(255, 255, 255, 0.1)',
  controlItemBgActiveHover: 'rgba(76, 106, 255, 0.3)',
  colorSplit: 'rgba(204, 213, 255, 0.1)',
  // colorBgContainer: 'radial-gradient(ellipse at 50% 0, #232c39 0%, #151e29 100%)',
  // colorBgElevated: 'rgba(255, 255, 255, 0.1)',
  colorBgSpotlight: '#484B5C',
  fontFamily: 'Inter',
};

export const antdDarkComponentsTheme: ThemeConfig['components'] = {
  Input: {
    colorBgContainer: '#272831',
    colorTextPlaceholder: 'rgba(214, 220, 255, 0.30)',
  },
  Select: {
    colorBgContainer: '#272831', // 下拉菜单背景
  },
  DatePicker: {
    colorBgContainer: '#272831', // 下拉菜单背景
  },
  Card: {
    colorBgContainer: 'rgba(255, 255, 255, 0.12)',
  },
  Tooltip: {
    colorBgSpotlight: '#2d2d2d', // 背景颜色
    colorTextLightSolid: '#ffffff', // 文字颜色（推荐白色）
  },
  Layout: {
    bodyBg: 'radial-gradient(ellipse at 50% 0, #232c39 0%, #151e29 100%)',
  },
};